import { useRouter } from 'next/router';
import { isPublicPage } from '../utils/routeHelper';
import LoadingLayout from './LoadingLayout';
import PublicPageLoadingLayout from './PublicPageLoadingLayout';

export default function GrispiLoadingLayout() {
    const { pathname } = useRouter();

    return isPublicPage(pathname) ? <PublicPageLoadingLayout /> : <LoadingLayout />;
}
